import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20platform%20background%20with%20flowing%20geometric%20shapes%20in%20warm%20amber%20and%20teal%20gradients%2C%20soft%20organic%20curves%2C%20minimalist%20aesthetic%2C%20clean%20design%2C%20warm%20lighting%2C%20artistic%20abstract%20composition%20with%20smooth%20gradations%20and%20delicate%20texture&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="17c平台背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      <div className="relative z-10 w-full max-w-[900px] mx-auto px-6 text-center">
        <p className="text-sm md:text-base text-primary-300 font-medium mb-4 tracking-widest uppercase opacity-0 animate-fade-in-up">
          探索17c的全部可能
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-6 leading-tight opacity-0 animate-fade-in-up animate-delay-100">
          您的核心<span className="text-primary-400">体验平台</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-[620px] mx-auto mb-10 leading-relaxed opacity-0 animate-fade-in-up animate-delay-200">
          17c集内容管理、数据分析、团队协作于一体，为个人和团队提供高效、安全、智能的全方位数字体验解决方案。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 opacity-0 animate-fade-in-up animate-delay-300">
          <Link
            to="/category/getting-started"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即开始
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-background-50/30 text-background-50 rounded-md text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}